import { getAxiosConfig, getFormattedError } from "./AxiosService";
import {
  ADD_FCM_TOKEN,
  GET_APP_LOAD_DATA,
  GET_EMOJI_CATEGORIES,
  GENERATE_VIDEO,
  GET_TEMPLATE_CATEGORIES,
  GET_TEMPLATE_BY_CATEGORY_SLUG,
  GET_TEMPLATE_BY_SLUG,
  GET_MUSICS,
  GET_FONTS,
  // Auth Endpoints
  LOGIN,
  LOGOUT,
  VERIFY_OTP,
  VERIFY_TOKEN,
  RESEND_OTP,

  UPDATE_CII,
  GET_CII,

  CREATE_RAZORPAY_ORDER_INV,
  SUCCESS_RAZORPAY_ORDER_INV,
  FAILED_RAZORPAY_ORDER_INV,
  // Plan subscription endpoints (used by PlansPage)
  GET_PLANS,
  CREATE_RAZORPAY_PLAN_ORDER,
  SUCCESS_RAZORPAY_PLAN_ORDER,
  FAILED_RAZORPAY_PLAN_ORDER,
  // User profile
  GET_USER_PROFILE,
} from "../config/endpoints";

/* =========================
   AUTHENTICATION
========================= */

const loginUser = async (params) => {
  console.log("Login Params:", params);
  const actionUrl = `${LOGIN}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params, // { auth_by: "phone", mobile: "..." }
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const verifyOtp = async (params) => {
  console.log("Verify OTP Params:", params);
  const actionUrl = `${VERIFY_OTP}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params, // { user_id, session_id, email_or_phone, otp }
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const verifyToken = async (params) => {
  console.log("Verify TOKEN Params:", params);
  const actionUrl = `${VERIFY_TOKEN}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers,
      'Authorization': params?.token ? `Bearer ${params.token}` : '',
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const resendOtp = async (params) => {
  console.log("Resend OTP Params:", params);
  const actionUrl = `${RESEND_OTP}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params, // { user_id: ... }
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const logoutUser = async (params) => {
  const actionUrl = `${LOGOUT}`;
  // We use type "none" but manually inject the token into headers
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: {},
    headers: {
      ...config.headers,
      Authorization: `Bearer ${params?.token}` // Pass token from params
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

/* =========================
   EXISTING FUNCTIONS
========================= */

const addFcmToken = async (params) => {
  console.log(params);
  const actionUrl = `${ADD_FCM_TOKEN}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const getAppLoadData = async (params) => {
  const actionUrl = `${GET_APP_LOAD_DATA}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const getEmojiCategories = async (params) => {
  const actionUrl = `${GET_EMOJI_CATEGORIES}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const getMusics = async (params) => {
  const actionUrl = `${GET_MUSICS}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const getFonts = async (params) => {
  const actionUrl = `${GET_FONTS}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const generateVideo = async (params) => {
  console.log(params);
  const actionUrl = `${GENERATE_VIDEO}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const getTemplateCategories = async (params) => {
  const actionUrl = `${GET_TEMPLATE_CATEGORIES}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const getTemplateByCategory = async (params) => {
  const actionUrl = `${GET_TEMPLATE_BY_CATEGORY_SLUG}/${params?.slug || 'none'}?paginate=10`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const getTemplateById = async (params) => {
  const actionUrl = `${GET_TEMPLATE_BY_SLUG}/${params?.slug || 'none'}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => {
      console.log(error, { actionUrl });
      return getFormattedError(error?.response?.data);
    });

  return response;
};

const updateCreatedInvitationInfo = async (params) => {
  const actionUrl = `${UPDATE_CII}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const getCreatedInvitations = async (params) => {
  const actionUrl = `${GET_CII}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "GET",
    params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};


const createInvitationOrder = async (params) => {
  const actionUrl = `${CREATE_RAZORPAY_ORDER_INV}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const verifyInvitationPayment = async (params) => {
  const actionUrl = `${SUCCESS_RAZORPAY_ORDER_INV}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

const failedInvitationPayment = async (params) => {
  const actionUrl = `${FAILED_RAZORPAY_ORDER_INV}`;
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });

  const response = await axiosInstance({
    url: actionUrl,
    method: "POST",
    data: params,
    headers: {
      ...config.headers
    }
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));

  return response;
};

/* =========================
   PLAN SUBSCRIPTION
   Used by PlansPage — iOS users visit the website to manage subscriptions
   because Apple App Store prohibits third-party in-app payment flows.
========================= */

const getUserProfile = async () => {
  // Auth required — returns user_info, active_plan, trial_used
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });
  const response = await axiosInstance({
    url: GET_USER_PROFILE,
    method: "GET",
    headers: { ...config.headers },
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));
  return response;
};

const getPlans = async () => {
  // Public endpoint — no auth required
  const { axiosInstance, config } = await getAxiosConfig({ type: "none" });
  const response = await axiosInstance({
    url: GET_PLANS,
    method: "GET",
    headers: { ...config.headers },
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));
  return response;
};

const createPlanOrder = async (params) => {
  // Auth required — creates a Razorpay order for the selected plan slug
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });
  const response = await axiosInstance({
    url: CREATE_RAZORPAY_PLAN_ORDER,
    method: "POST",
    data: params, // { plan_slug }
    headers: { ...config.headers },
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));
  return response;
};

const verifyPlanPayment = async (params) => {
  // Auth required — verifies Razorpay signature and activates the plan
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });
  const response = await axiosInstance({
    url: SUCCESS_RAZORPAY_PLAN_ORDER,
    method: "POST",
    data: params, // { plan_slug, razorpay_order_id, razorpay_payment_id, razorpay_signature }
    headers: { ...config.headers },
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));
  return response;
};

const failedPlanPayment = async (params) => {
  // Auth required — logs a failed plan payment attempt
  const { axiosInstance, config } = await getAxiosConfig({ type: "auth" });
  const response = await axiosInstance({
    url: FAILED_RAZORPAY_PLAN_ORDER,
    method: "POST",
    data: params, // { razorpay_order_id, razorpay_payment_id, error }
    headers: { ...config.headers },
  })
    .then((res) => res?.data || null)
    .catch((error) => getFormattedError(error?.response?.data));
  return response;
};


export default {
  // Auth
  loginUser,
  verifyOtp,
  verifyToken,
  resendOtp,
  logoutUser,
  
  
  addFcmToken,
  getAppLoadData,
  getEmojiCategories,
  getMusics,
  getFonts,
  generateVideo,
  getTemplateCategories,
  getTemplateByCategory,
  getTemplateById,
  updateCreatedInvitationInfo,
  getCreatedInvitations,
  createInvitationOrder,
  verifyInvitationPayment,
  failedInvitationPayment,
  // User profile
  getUserProfile,
  // Plan subscription
  getPlans,
  createPlanOrder,
  verifyPlanPayment,
  failedPlanPayment,
};